import { render } from "./Admin.vue?vue&type=template&id=594de7ca"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/xianbinlin/workplace/work/projects/notionWeb/app-notion2web/node_modules/vue-loader/dist/exportHelper.js"
export default /*#__PURE__*/exportComponent(script, [['render',render]])